import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { isMobileBuild } from '@/lib/mobileBuild';

/**
 * Mobile-only cold-start guard. When the app launches with an existing session
 * (auto-logged-in returning user), route them through the Welcome Back screen
 * once per app session. Completely inert on web (REACT_APP_BUILD_TARGET !== 'mobile').
 */
const MobileWelcomeGate = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!isMobileBuild()) return;

    const token = localStorage.getItem('token');
    const alreadyShown = sessionStorage.getItem('welcomeBackShown');
    const entryPaths = ['/', '/dashboard', '/dashboard/modules'];

    if (token && !alreadyShown && entryPaths.includes(location.pathname)) {
      navigate('/welcome-back', { replace: true });
    }
  }, []);

  return null;
};

export default MobileWelcomeGate;
